export default __webpack_public_path__ + "static/media/image-not-found-scaled.295cf90a.jpg";